module.exports = __webpack_public_path__ + "static/media/uet.133a4b8b.png";